import axios from "axios";
import { getToken } from "./token";

// Формирует текст ошибки для тоста: "<baseMessage> (413: request entity too large)".
// Детали берутся из ответа сервера (Express отвечает {message}), затем из statusText,
// затем из err.message; если деталей нет — возвращается baseMessage как есть.
export const formatRequestError = (baseMessage, err) => {
  const status = err?.response?.status;
  const details =
    err?.response?.data?.message ||
    err?.response?.statusText ||
    err?.message;
  const parts = [status, details].filter(Boolean).join(": ");
  return parts ? `${baseMessage} (${parts})` : baseMessage;
};

export const postRequest = async (url, body = {}, options = {}) => {
  const { suppressAuthReset, ...axiosOptions } = options || {};
  return axios
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      ...axiosOptions,
    })
    .catch((err) => {
      if (err?.response?.status === 401 && !suppressAuthReset) {
        localStorage.removeItem("accessToken");
        window.location.reload();
      }
      console.error("HTTP POST error", {
        url,
        status: err?.response?.status,
        data: err?.response?.data,
      });
      throw err;
    });
};

export const getRequest = async (url, options = {}) => {
  const { suppressAuthReset, ...axiosOptions } = options || {};
  return axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      ...axiosOptions,
    })
    .catch((err) => {
      if (err?.response?.status === 401 && !suppressAuthReset) {
        localStorage.removeItem("accessToken");
        window.location.reload();
      }
      console.error("HTTP GET error", {
        url,
        status: err?.response?.status,
        data: err?.response?.data,
      });
      throw err;
    });
};

export const deleteRequest = async (url, options = {}) => {
  const { suppressAuthReset, ...axiosOptions } = options || {};
  return axios
    .delete(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      ...axiosOptions,
    })
    .catch((err) => {
      if (err?.response?.status === 401 && !suppressAuthReset) {
        localStorage.removeItem("accessToken");
        window.location.reload();
      }
      console.error("HTTP DELETE error", {
        url,
        status: err?.response?.status,
        data: err?.response?.data,
      });
      throw err;
    });
};

export const patchRequest = async (url, body, options = {}) => {
  const { suppressAuthReset, ...axiosOptions } = options || {};
  return axios
    .patch(url, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      ...axiosOptions,
    })
    .catch((err) => {
      if (err?.response?.status === 401 && !suppressAuthReset) {
        localStorage.removeItem("accessToken");
        window.location.reload();
      }
      console.error("HTTP PATCH error", {
        url,
        status: err?.response?.status,
        data: err?.response?.data,
      });
      throw err;
    });
};
